import { Dispatch } from "redux"
import request from "../../Requests/requests"
import { loadTemplates } from "../../store/repeatTemplateReducer"


export function getRepeatTemplates() {
    return async (dispatch: Dispatch)=> {
        try {
            const response = await request.get('/RepitTemplate/List', {params: {
                UserId: localStorage.getItem('userID'),
                TypeSort: 5,
                IsAscending: true,
            }})
            const data = response.data
            dispatch(loadTemplates(data))
            return data
        } catch (error) {
            return error
        }
    }
}